import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { IconDetailComponent } from '../../../common/icon-detail/icon-detail.component';
import { StatusIndicatorComponent } from '../../../common/status-indicator/status-indicator.component';
import {UserGroup } from '../../../domain/models/user-group.model';
import { MatTabsModule } from '@angular/material/tabs';
import { UserGroupServiceService } from '../../../domain/services/user-group/user-group.service.service';
import { UsergroupUsersComponent } from '../usergroup-users/usergroup-users.component';
import { CustomDialogFactory } from '../../../domain/services/dialog/custom-dialog.factory';
import { DialogTypeEnum } from '../../../domain/enums/dialog-type.enum';
import { PermissionsComponent } from '../permissions/permissions.component';
import { DialogService } from '../../../domain/services/dialog/dialog.service';
import { DIALOG } from '../../../domain/constants/customer-search.constants';

@Component({
  selector: 'app-manage-user-group',
  standalone: true,
  imports: [
    MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
        FormsModule,
        MatPaginatorModule,
        RouterModule,
        MatTableModule,
        MatInputModule,
        MatSortModule,
        MatSelectModule,
        CommonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTableModule,
        MatTabsModule,
        UsergroupUsersComponent,
        PermissionsComponent
  ],
  templateUrl: './manage-user-group.component.html',
  styleUrl: './manage-user-group.component.css'
})
export class ManageUserGroupComponent implements OnInit{
  userGroup!: UserGroup ;
    @ViewChild(PermissionsComponent) permissionForm!: PermissionsComponent;
     @ViewChild(UsergroupUsersComponent) usersMembers!: UsergroupUsersComponent;
  isLoading = false;
  constructor(  private readonly router: Router,private readonly dialogService: DialogService,private readonly route: ActivatedRoute, private userGroupServices : UserGroupServiceService,private readonly dialog: CustomDialogFactory) {
  }
  ngOnInit(): void {
    const id: number = Number(this.route.snapshot.params['id']);
    if (id) {
       this.userGroupServices.getById(id).subscribe(task => {
        this.userGroup = task; 
      });
    }
  }

  editUserGroupModal(): void {
  
     this.dialog.openDialog(DialogTypeEnum.NEW_USER_GROUP, this.userGroup, (data: UserGroup) => {
      
            this.userGroupServices.update(data).subscribe(value => {
             this.userGroup = data;
            });
             });
  }

  saveAll(){
      this.dialogService.openConfirmationDialog("Are you sure you want to apply the changes to the user group?","All permissions and members associated with this group will be affected.", () => {
    this.isLoading = true;
    this.permissionForm.saveOptions();
    this.usersMembers.save();
    this.isLoading = false;
        });
  }

  deleteGroup(){
    this.dialogService.openDeletedDialog("Are you sure you want to delete this user group from the platform ?","Once you confirm this action, this can’t be undone.", (value: boolean) => {
    if (value){  this.userGroupServices.deleteGroup(this.userGroup?.id).subscribe(value => {
            this.dialogService
              .openSuccesDialog("Success", "User Group deleted successfully.")
              .subscribe(() => { 
                 this.router.navigate(['app/usersGroup']);
              });
          });
    }
        }); 
  }

}
